import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';

const PREMIUM_MODAL_SHOWN_KEY = 'premium_modal_shown';
const PREMIUM_MODAL_DISMISSED_KEY = 'premium_modal_dismissed_at';
const SHOW_INTERVAL_DAYS = 1; // Show again after 7 days if dismissed

export const usePremiumModal = () => {
  
  const [showModal, setShowModal] = useState(false);
  const user = useSelector((state: RootState) => state.auth.user);
  const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);

  useEffect(() => {
    // TESTING MODE: Show modal every time for testing
    // TODO: Remove this and uncomment production logic below
    
    // Don't show if user is not authenticated
    // if (!isAuthenticated || !user) {
    //   return;
    // }

    // // Don't show if user is already premium
    // if (user.isPremium || user.subscriptionStatus === 'active') {
    //   return;
    // }

    // // Show modal after a short delay
    // const timer = setTimeout(() => {
    //   setShowModal(true);
    // }, 1000);

    // return () => clearTimeout(timer);

    /* PRODUCTION LOGIC - Uncomment when testing is done: */
    
    // Don't show if user is not authenticated or already premium
    if (!isAuthenticated || !user) {
      return;
    }

    // Don't show if user is already premium
    if (user.isPremium || user.subscriptionStatus === 'active') {
      return;
    }

    // Check if modal was already shown in this session
    const shownInSession = sessionStorage.getItem(PREMIUM_MODAL_SHOWN_KEY);
    if (shownInSession) {
      return;
    }

    // Check if modal was dismissed recently
    const dismissedAt = localStorage.getItem(PREMIUM_MODAL_DISMISSED_KEY);
    if (dismissedAt) {
      const dismissedDate = new Date(dismissedAt);
      const daysSinceDismissed = (Date.now() - dismissedDate.getTime()) / (1000 * 60 * 60 * 24);
      
      if (daysSinceDismissed < SHOW_INTERVAL_DAYS) {
        return;
      }
    }

    // Show modal after a short delay (better UX)
    const timer = setTimeout(() => {
      setShowModal(true);
      sessionStorage.setItem(PREMIUM_MODAL_SHOWN_KEY, 'true');
    }, 2000); // 2 second delay after login

    return () => clearTimeout(timer);
    
   
  }, [isAuthenticated, user]);

  const handleClose = () => {
    setShowModal(false);
    localStorage.setItem(PREMIUM_MODAL_DISMISSED_KEY, new Date().toISOString());
  };

  const handleDontShowAgain = () => {
    setShowModal(false);
    // Set a far future date to effectively disable
    const farFuture = new Date();
    farFuture.setFullYear(farFuture.getFullYear() + 10);
    localStorage.setItem(PREMIUM_MODAL_DISMISSED_KEY, farFuture.toISOString());
  };

  return {
    showModal,
    handleClose,
    handleDontShowAgain,
  };
};
